/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/gpt_message_qa" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGptMessageQa } from "./constants";
import type { EngagementAppGroupIdGptMessageQaResult } from "./types";

export const getEngagementAppGroupIdGptMessageQa = reactQueryFetcherAdapter(
  engagementAppGroupIdGptMessageQa,
  (
    signal: AbortSignal,
    appGroupId: string,
    campaignId: string,
    message: string
  ): Promise<EngagementAppGroupIdGptMessageQaResult> => {
    return fetch(
      `/engagement/${appGroupId}/gpt_message_qa`,
      "POST",
      { campaign_id: campaignId, message },
      { signal }
    );
  }
);
